import { Modal, csx } from '@vtex/admin-ui'
import { DisclosureState } from 'ariakit'

import React, { ReactNode } from 'react'

interface FullModalProps {
  state: DisclosureState
  children: ReactNode
}

const FullModal = ({ state, children }: FullModalProps) => (
  <Modal
    className={csx({
      height: '100% !important',
      maxHeight: '100%',
      width: '100%',
      border: '0',
      borderWidth: '0px',
      borderRadius: '0px',
      margin: '$space-0',
      '@desktop': {
        width: 'auto',
      },
      '@tablet': {
        height: 'auto',
        width: 'auto',
        borderWidth: '1px',
        borderRadius: '3px',
        border: '1px solid hsla(0, 0%, 87%, 1)',
      },
      display: 'flex',
      flexDirection: 'column',
    })}
    aria-label="full_modal"
    state={state}
    hideOnEscape={false}
    hideOnInteractOutside={false}
  >
    {children}
  </Modal>
)

export default FullModal
